import { AngebotsId } from '@ps20-frontend/shop-integration-redux';

export function getIndexForToolbarElement<T extends AngebotsId>(
  element: T,
  angeboteInWarenkorb: Array<AngebotsId>,
): number {
  return angeboteInWarenkorb.findIndex(
    angebot => angebot.appId === element.appId && angebot.angebotsId === element.angebotsId,
  );
}
